export default __webpack_public_path__ + "static/media/barnjoo.61355439.jpeg";